let Chart = null;

async function ensureChart() {
  if (!Chart) {
    const mod = await import(/* webpackChunkName: "chartjs" */ 'chart.js/auto');
    Chart = mod.default;
  }
  return Chart;
}

$(document).on("turbolinks:load", async function () {
  if (!$('.usage-chart').is('*')) return;

  await ensureChart();

  $('.usage-chart').each(function(index, element){
    drawUsageChart(element);
  });
});

function drawUsageChart(element) {
  var data = $(element).data('chart');
  if (!data) return;

  var suffix = $(element).data('suffix') || '';
  var showLegend = data.datasets.length > 1;

  data.datasets.forEach(function(dataset) {
    dataset.borderWidth = 2;
    dataset.pointRadius = 0;
    dataset.pointHoverRadius = 4;
    dataset.pointHoverBorderWidth = 2;
    dataset.pointHoverBorderColor = '#fff';
    dataset.tension = 0.25;
    dataset.spanGaps = false;
  });

  return new Chart(element, {
    type: 'line',
    data: data,
    options: {
      maintainAspectRatio: false,
      animation: {
        easing: 'easeOutQuart'
      },
      interaction: {
        intersect: false,
        mode: 'index'
      },
      hover: {
        mode: 'index',
        intersect: false
      },
      scales: {
        y: {
          display: true,
          beginAtZero: true,
          grid: {
            drawBorder: false,
            color: 'rgba(0, 0, 0, 0.06)'
          },
          ticks: {
            callback: function(value) {
              return value.toLocaleString() + suffix;
            }
          }
        },
        x: {
          display: true,
          grid: {
            display: false
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 14,
            maxRotation: 0
          }
        }
      },
      plugins: {
        legend: {
          display: showLegend,
          position: 'top',
          align: 'start',
          labels: {
            usePointStyle: true,
            pointStyle: 'circle',
            boxWidth: 18,
            padding: 20
          }
        },
        tooltip: {
          displayColors: true,
          usePointStyle: true,
          filter: function(context) {
            return context.parsed.y !== null;
          },
          callbacks: {
            label: function(context) {
              var label = context.dataset.label || '';

              if (label) {
                label += ': ';
              }

              return label + context.parsed.y.toLocaleString() + suffix;
            }
          }
        }
      }
    }
  });
}
